import React, { useState, useEffect } from 'react'
import { Spin, Button, notification } from 'antd'
import { useWeb3React } from '@web3-react/core'
import { cancelPool } from '../../../Blockchain/services/presale.service'


export default function PoolCancelButton(props) {
  const { isPoolStatusLoading, poolStatus, presaleAddress } = props

  const [canCancelThePool, setCanCancelThePool] = useState(false)
  const [isCancelPoolLoading, setIsCancelPoolLoading] = useState(false)
  const { account, library } = useWeb3React()

  useEffect(() => {
    if (poolStatus) {
      if (poolStatus?.statusCode === 'ongoing') {
        setCanCancelThePool(true)
      } else {
        setCanCancelThePool(false)
      }
    }
  }, [poolStatus])

  const handleCancelPool = async () => {
    try {

      if (!account) {
        notification['error']({
          message: 'Authentication Error',
          description:
            'Please connect your wallet to proceed',
        });
        setIsCancelPoolLoading(false)
        return
      }

      setIsCancelPoolLoading(true)
      const response = await cancelPool(presaleAddress, library.getSigner())
      console.log("response ", response)
      setIsCancelPoolLoading(false)
      notification['success']({
        message: 'Success',
        description: 'You have successfully cancel the private pool.',
      });
    } catch (error) {
      setIsCancelPoolLoading(false)
      console.error("ERROR while cancel  the private sale pool ", error)
      notification['error']({
        message: 'Transaction execution failed',
        description: error,
      });

    }
  }

  return (
    <div className='finalized-pool-button-container'>

      {
        isPoolStatusLoading ? (
          <div className='loader text-centered'>
            <Spin size='small' />
          </div>
        ) : (
          <Button
            loading={isCancelPoolLoading}
            disabled={canCancelThePool}
            onClick={handleCancelPool}
            block
            type="primary">
            Cancel the pool
          </Button>
        )
      }

    </div>
  )
}
